import React, { useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";

import { confirmPasswordReset } from "../../services/authNew";

const ConfirmResetPassword = (props) => {
  const { setToast } = props;
  const location = useLocation();
  const history = useHistory();

  const token =
    new URLSearchParams(location.search).get("token") ||
    new URLSearchParams(location.search).get("reset_token");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isResetting, setIsResetting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!token) {
      setToast({
        show: true,
        type: "warning",
        message: "Invalid or missing reset link. Request a new password reset.",
      });
      return;
    }
    if (newPassword !== confirmPassword) {
      setToast({
        show: true,
        type: "warning",
        message: "Passwords do not match",
      });
      return;
    }
    if (newPassword.length < 8) {
      setToast({
        show: true,
        type: "warning",
        message: "Password must be at least 8 characters",
      });
      return;
    }

    setIsResetting(true);
    confirmPasswordReset(token, newPassword)
      .then((msg) => {
        setIsResetting(false);
        setToast({
          show: true,
          type: "success",
          message: msg || "Password has been reset. You can log in now.",
        });
        history.push("/login");
      })
      .catch((error) => {
        setIsResetting(false);
        setToast({
          show: true,
          type: "danger",
          message: error.message || "Failed to reset password",
        });
      });
  };

  if (!token) {
    return (
      <div>
        <p className="bottom-breather">
          This link is invalid or has expired. Please request a new password
          reset.
        </p>
        <Link to="/forgot-password">Request password reset</Link>
      </div>
    );
  }

  return (
    <div>
      <p className="with-icon positive bottom-breather">
        Enter your new password below.
      </p>
      <form className="form-block w-form" onSubmit={handleSubmit}>
        <div className="control">
          <label>New password</label>
          <input
            type="password"
            className="input large w-input"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={8}
            placeholder="At least 8 characters"
          />
        </div>
        <div className="control">
          <label>Confirm new password</label>
          <input
            type="password"
            className="input large w-input"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength={8}
          />
        </div>
        {isResetting ? (
          <button
            type="button"
            className="button primary large wide w-button is-disabled"
            disabled
          >
            Resetting password...
          </button>
        ) : (
          <button type="submit" className="button primary large wide w-button">
            Reset password
          </button>
        )}
        <div>
          <Link to="/login">Back to log in</Link>
        </div>
      </form>
    </div>
  );
};

export default ConfirmResetPassword;
